import { getSubStepValues } from '#models/general/steps';
import Input from '#components/general/Input';

import { TIME_RUNNING_FIELDS, WASH_SUBSTEPS_IDS } from './constants';

export const getTimeRunningFields = ({ values, errors }) => {
  const getTimeInValues = getSubStepValues(WASH_SUBSTEPS_IDS.TIME_RUNNING, values, errors);
  return [
    {
      ...getTimeInValues(TIME_RUNNING_FIELDS.DATE_AND_TIME_RUNNING),
      Component: Input,
      type: 'datetime-local'
    }
  ];
};
